export const REPAIR_ITEM_OPTIONS = [
  'Left Temple',
  'Right Temple',
  'Left Hinge',
  'Right Hinge',
  'Bridge',
  'Frame Front',
  'Nosepad Replacement',
  'Nosepad Install / Addition',
  'Other',
] as const;

export type RepairItem = typeof REPAIR_ITEM_OPTIONS[number];

export const NOSEPAD_INSTALL_ITEM = 'Nosepad Install / Addition';
export const NOSEPAD_ADDITION_ITEM = 'Nosepad Addition';
export const OTHER_REPAIR_ITEM = 'Other';

export function normalizeRepairItem(item: string): string {
  const value = String(item || '').trim();
  if (value === NOSEPAD_ADDITION_ITEM || value === 'Nosepad Install') {
    return NOSEPAD_INSTALL_ITEM;
  }
  return value;
}

export function normalizeRepairItems(items?: string[]): string[] {
  return Array.from(
    new Set((items || []).map(normalizeRepairItem).filter(Boolean))
  );
}

export function isNosepadRepairItem(item: string): boolean {
  const value = normalizeRepairItem(item);
  return value === NOSEPAD_INSTALL_ITEM || value === 'Nosepad Replacement';
}
